import {Animated, Platform} from 'react-native';
import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled, {css} from 'styled-components/native';

export const Container = styled.View`

    margin-bottom: ${RFValue(12)}px;
    gap:${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(10)}px;
`;

export const Grid = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: ${RFValue(12)}px;
  margin: 0 24px 0;
`;

export const PulseWrapper = styled.View`
  width: 48%;
  position: relative;
  overflow: visible;
`;

export const PulseRing = styled(Animated.View)<{pulseColor: string}>`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: ${RFValue(16)}px;
  border-width: 1.5px;
  border-color: ${({pulseColor}) => pulseColor};
  background-color: ${({pulseColor}) => pulseColor};
`;

export const CardWrapper = styled.View<{cardBg?: string; cardBorder?: string}>`
  width: 100%;
  height: ${RFValue(125)}px;
  border-radius: ${RFValue(16)}px;

  background-color: ${({cardBg, theme}) => cardBg ?? theme.colors.shape};
  border: 1px solid ${({cardBorder, theme}) => cardBorder  ?? theme.colors.border2};

  ${({theme}) =>
      Platform.OS === 'ios'
        ? css`
            shadow-color: ${theme.colors.dark_shadow};
            shadow-offset: 0px 4px;
            shadow-opacity: 0.1;
            shadow-radius: 9px;
          `
        : css`
       
          `}
`;

export const Card = styled.TouchableOpacity`
  border-radius: ${RFValue(14)}px;
  overflow: hidden;
  padding: ${RFValue(8)}px;
  flex: 1;
  
`;

export const IconWrapper = styled.View<{bgColor: string}>`
  margin-bottom: ${RFValue(8)}px;
  width: ${RFValue(32)}px;
   height: ${RFValue(32)}px;
   justify-content: center;
   align-items: center;
    background-color: rgba(23,183,15,1);
    border-radius: ${RFValue(32)}px;
`;

export const ImageWrapper = styled(FastImage)<{bgColor: string}>`
  margin-bottom: ${RFValue(8)}px;
  width: ${RFValue(32)}px;
   height: ${RFValue(32)}px;
   justify-content: center;
   align-items: center;
    background-color: rgba(23,183,15,1);
    border-radius: ${RFValue(32)}px;
`;


export const CardTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(4)}px;
`;

export const CardDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
  line-height: ${RFValue(14)}px;
`;

export const ArrowRow = styled.View`
  position: absolute;
  top: ${RFValue(12)}px;
  right: ${RFValue(14)}px;
`;

export const Arrow = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
`;
